import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { OperationV2Guard } from "../shared/guards/operation-v2.guard";
import { ScannerV2Guard } from "../shared/guards/scanner-v2.guard";
import { CardapioPage } from "./cardapio/cardapio.page";
import { ContaPage } from "./conta/conta.page";
import { GalleryPage } from "./gallery/gallery.page";
import { MesaPage } from "./mesa/mesa.page";
import { RatingPage } from "./rating/rating.page";
import { V2HomePage } from "./v2-home/v2-home.page";

import { V2Page } from "./v2.page";

const routes: Routes = [
  {
    path: "config",
    loadChildren: () => import("./config/config.module").then((m) => m.ConfigPageModule),
  },

  {
    path: "",
    component: V2Page,
    canActivate: [ScannerV2Guard, OperationV2Guard],
    children: [
      {
        path: "home",
        component: V2HomePage,
      },
      {
        path: "cardapio",
        component: CardapioPage,
      },
      {
        path: "gallery",
        component: GalleryPage,
      },
      {
        path: "mesa",
        component: MesaPage,
      },
      {
        path: "rating",
        component: RatingPage,
      },
      {
        path: "conta",
        component: ContaPage,
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "home",
      },
    ],
  },
  {
    path: "scanner",
    loadChildren: () => import("../pages/scanner/scanner.module").then((m) => m.ScannerPageModule),
  },
  {
    path: "table-page",
    loadChildren: () => import("./finishing-pages/table-page/table-page.module").then((m) => m.TablePagePageModule),
  },
  {
    path: "user-info-request-consumo",
    loadChildren: () => import("./finishing-pages/user-info-request-consumo/user-info-request-consumo.module").then((m) => m.UserInfoRequestConsumoPageModule),
  },
  {
    path: "historico",
    loadChildren: () => import("./orders/orders.module").then((m) => m.OrdersPageModule),
  },
  {
    path: "conta",
    loadChildren: () => import("./account/account.module").then((m) => m.AccountPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class V2RoutingModule {}
